import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import { AutoAwesome } from "@mui/icons-material";
import AIImageGeneratorDialog from "./AIImageGeneratorDialog";

const USeAiImage = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleImageSelect = (imageData) => {
    console.log("Selected image:", imageData);
    // Handle the selected image (save to state, upload, etc.)
  };

  return (
    <Box sx={{ p: 4 }}>
      <Button
        variant="contained"
        startIcon={<AutoAwesome />}
        onClick={() => setDialogOpen(true)}
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          px: 4,
          py: 1.5,
          fontSize: "1.1rem",
          borderRadius: 2,
        }}
      >
        Generate AI Image
      </Button>

      <AIImageGeneratorDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onImageSelect={handleImageSelect}
      />
    </Box>
  );
};

export default USeAiImage;
